/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5′-ATGCTAGC-3′ → reverse complement → GCTAGCAT (the reverse-strand primer).`)
};

const es_revcomp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5′-ATGCTAGC-3′ → complemento inverso → GCTAGCAT (el cebador de la hebra inversa).`)
};

const de_revcomp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5′-ATGCTAGC-3′ → reverses Komplement → GCTAGCAT (der Primer für den Gegenstrang).`)
};

const nl_revcomp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5′-ATGCTAGC-3′ → omgekeerd complement → GCTAGCAT (de reverse-strand primer).`)
};

const fr_revcomp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5′-ATGCTAGC-3′ → complément inverse → GCTAGCAT (l'amorce du brin inverse).`)
};

const it_revcomp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5′-ATGCTAGC-3′ → complemento inverso → GCTAGCAT (il primer del filamento inverso).`)
};

const pt_br2_revcomp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5′-ATGCTAGC-3′ → complemento reverso → GCTAGCAT (o primer da fita reversa).`)
};

const pt_revcomp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5′-ATGCTAGC-3′ → complemento reverso → GCTAGCAT (o primer da cadeia reversa).`)
};

const ja_revcomp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5′-ATGCTAGC-3′ → 逆相補配列 → GCTAGCAT（逆鎖プライマー）。`)
};

const zh_revcomp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5′-ATGCTAGC-3′ → 反向互补 → GCTAGCAT（反向链引物）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_ex2", locale)
	if (locale === "en") return en_revcomp_ex2(inputs)
	if (locale === "es") return es_revcomp_ex2(inputs)
	if (locale === "de") return de_revcomp_ex2(inputs)
	if (locale === "nl") return nl_revcomp_ex2(inputs)
	if (locale === "fr") return fr_revcomp_ex2(inputs)
	if (locale === "it") return it_revcomp_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_ex2(inputs)
	if (locale === "pt") return pt_revcomp_ex2(inputs)
	if (locale === "ja") return ja_revcomp_ex2(inputs)
	return zh_revcomp_ex2(inputs)
};